import { Routes, Route } from "react-router-dom";
import {
	faFileCircleQuestion,
	faFilePen,
} from "@fortawesome/pro-regular-svg-icons";
import { faUserAlt } from "@fortawesome/pro-solid-svg-icons";

import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import Page404 from "../views/errors/Page404";

import PageLogin from "../views/public/PageLogin/PageLogin";
import PageHome from "../views/public/PageHome/PageHome";
import PageScoreCard from "../views/public/PageScoreCard/PageScoreCard";
import PageDashboard from "../views/private/PageDashboard/PageDashboard";
import PageSurveyForm from "../views/private/PageSurvey/PageSurveyForm";
import PageSurveyPending from "../views/private/PageSurveyPending/PageSurveyPending";
import PageNews from "../views/private/PageNews/PageNews";
import PageProfile from "../views/private/PageProfile/PageProfile";
import PageScoreCardForm from "../views/public/PageScoreCardForm/PageScoreCardForm";
import PageScoreCardFormSend from "../views/public/PageScoreCardFormSend/PageScoreCardFormSend";
import PageScoreCardFormSuccess from "../views/public/PageScoreCardFormSuccess/PageScoreCardFormSuccess";
import PageScoreCardFormThankYou from "../views/public/PageScoreCardFormThankYou/PageScoreCardFormThankYou";
import PageScoreCardGraph from "../views/public/PageScoreCardGraph/PageScoreCardGraph";
import PageSetupPassword from "../views/public/PageSetupPassword/PageSetupPassword";
import PageScorecard from "../views/private/PageScorecard/PageScorecard";
import PageReport from "../views/private/PageReport/PageReport";

export default function RouteList() {
	return (
		<Routes>
			<Route
				path="/login"
				element={
					<PublicRoute title="LOGIN" pageId="PageLogin" component={PageLogin} />
				}
			/>
			<Route
				path="/setup-password/:token"
				element={
					<PublicRoute
						title="SETUP PASSWORD"
						pageId="PageSetupPassword"
						component={PageSetupPassword}
					/>
				}
			/>

			<Route
				path="/"
				element={
					<PublicRoute title="HOME" pageId="PageHome" component={PageHome} />
				}
			/>
			<Route
				path="/scorecard"
				element={
					<PublicRoute
						title="SCORECARD"
						pageId="PageScoreCard"
						component={PageScoreCard}
					/>
				}
			/>
			<Route
				path="/scorecard/form"
				element={
					<PublicRoute
						title="SCORECARD FORM"
						pageId="PageScoreCardForm"
						component={PageScoreCardForm}
					/>
				}
			/>
			<Route
				path="/scorecard/form/send"
				element={
					<PublicRoute
						title="SCORECARD SEND"
						pageId="PageScoreCardFormSend"
						component={PageScoreCardFormSend}
					/>
				}
			/>
			<Route
				path="/scorecard/form/success"
				element={
					<PublicRoute
						title="SCORECARD SUCCESS"
						pageId="PageScoreCardFormSuccess"
						component={PageScoreCardFormSuccess}
					/>
				}
			/>
			<Route
				path="/scorecard/form/thank-you"
				element={
					<PublicRoute
						title="SCORECARD THANK YOU"
						pageId="PageScoreCardFormThankYou"
						component={PageScoreCardFormThankYou}
					/>
				}
			/>
			<Route
				path="/scorecard-graph-result/:code"
				element={
					<PublicRoute
						title="SCORECARD GRAPH RESULT"
						pageId="PageScoreCardGraph"
						component={PageScoreCardGraph}
					/>
				}
			/>

			<Route
				path="/dashboard"
				element={
					<PrivateRoute
						title="Dashboard"
						subtitle="SURVEY"
						pageId="PageDashboard"
						pageHeaderIcon={faFileCircleQuestion}
						breadcrumb={[]}
						component={PageDashboard}
					/>
				}
			/>

			<Route
				path="/scorecards"
				element={
					<PrivateRoute
						title="Scorecard"
						subtitle="VIEW"
						pageId="PageScorecard"
						pageHeaderIcon={faFilePen}
						breadcrumb={[
							{
								name: "Scorecard",
							},
						]}
						component={PageScorecard}
					/>
				}
			/>

			<Route
				path="/reports"
				element={
					<PrivateRoute
						title="Report"
						subtitle="VIEW"
						pageId="PageReport"
						pageHeaderIcon={faFilePen}
						breadcrumb={[
							{
								name: "Report",
							},
						]}
						component={PageReport}
					/>
				}
			/>

			<Route
				path="/survey"
				element={
					<PrivateRoute
						title="Survey"
						subtitle="FORM"
						pageId="PageSurveyForm"
						pageHeaderIcon={faFilePen}
						breadcrumb={[
							{
								name: "Survey",
							},
							{
								name: "Form",
							},
						]}
						component={PageSurveyForm}
					/>
				}
			/>

			<Route
				path="/survey/add/:form_id/:index"
				element={
					<PrivateRoute
						title="Survey"
						subtitle="FORM"
						pageId="PageSurveyForm"
						pageHeaderIcon={faFilePen}
						breadcrumb={[
							{
								name: "Survey",
							},
							{
								name: "Form",
							},
						]}
						component={PageSurveyForm}
					/>
				}
			/>

			<Route
				path="/survey/edit/:index"
				element={
					<PrivateRoute
						title="Survey"
						subtitle="FORM"
						pageId="PageSurveyForm"
						pageHeaderIcon={faFilePen}
						breadcrumb={[
							{
								name: "Survey",
							},
							{
								name: "Form",
							},
						]}
						component={PageSurveyForm}
					/>
				}
			/>

			<Route
				path="/survey/pending"
				element={
					<PrivateRoute
						title="Survey"
						subtitle="PENDING"
						pageId="PageSurveyPending"
						pageHeaderIcon={faFilePen}
						breadcrumb={[
							{
								name: "Survey",
							},
							{
								name: "Pending",
							},
						]}
						component={PageSurveyPending}
					/>
				}
			/>

			<Route
				path="/news"
				element={
					<PrivateRoute
						title="News"
						subtitle="VIEW"
						pageId="PageNews"
						pageHeaderIcon={faFilePen}
						breadcrumb={[
							{
								name: "News",
							},
						]}
						component={PageNews}
					/>
				}
			/>

			<Route
				path="/account-profile"
				element={
					<PrivateRoute
						title="Profile"
						subtitle="ACCOUNT"
						pageId="PageAccountProfile"
						pageHeaderIcon={faUserAlt}
						breadcrumb={[
							{
								name: "Profile",
							},
						]}
						component={PageProfile}
					/>
				}
			/>

			<Route path="*" element={<Page404 pageId="Page404" />} />
		</Routes>
	);
}
